import type { LocaleDictionary } from "@/i18n/types";

const nsAccountMenuEN = {
  trigger: {
    ariaLabel: "Account Menu",
  },
  item: {
    accountSetting: "Account Settings",
    help: "Help",
    signOut: "Log Out",
  },
  adminGroup: {
    header: "Administrators",
    adminPage: "AA Admin Page",
  },
  footer: {
    about: "About this service",
  },
  aboutDialog: {
    title: "About this service",
    version: ({ version }: { version: string }) => `Version: ${version}`,
    closeButton: "Close",
  },
  signOutDialog: {
    title: "Log Out",
    message: "Are you sure you want to log out of the current account?",
    confirmButton: "Log Out",
    cancelButton: "Cancel",
  },
} satisfies LocaleDictionary;

export default nsAccountMenuEN;
